import {
  AdjustmentsHorizontalIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

import { classNames } from "../../shared/utility";
import Button from "../ui/Button";

export default function FilterDropdown(props) {
  const {
    actionCall,
    activeFilterCount = 0,
    filterComponents,
    hideResetAll = false,
    resetFilters,
    showFilters,
    setShowFilters,
    title,
  } = props;

  return (
    <div className="relative block">
      <Button
        type="button"
        variant={activeFilterCount > 0 ? "soft" : "secondary"}
        size="md"
        className="ml-0"
        onClick={() => setShowFilters(true)}
      >
        <AdjustmentsHorizontalIcon className="h-5 w-5" aria-hidden="true" />
        {title ? title : "Filters"}
        {activeFilterCount > 0 ? (
          <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-[#16A34A] px-1.5 text-xs font-bold leading-none text-white">
            {activeFilterCount}
          </span>
        ) : null}
      </Button>

      <div
        className={classNames(
          showFilters ? null : "hidden",
          "absolute right-0 z-50 mt-2 w-[min(24rem,calc(100vw-2rem))] origin-top-right overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white shadow-xl focus:outline-none",
        )}
      >
        <div className="flex items-center justify-between border-b border-[#E2E8F0] bg-[#F6F8FB] px-4 py-3">
          <div>
            <p className="text-sm font-semibold text-[#0F172A]">
              {title ? title : "Filters"}
            </p>
            <p className="text-xs text-[#64748B]">
              Narrow the records shown in this view.
            </p>
          </div>
          <button
            type="button"
            onClick={() => setShowFilters(false)}
            className="rounded-full p-1.5 text-[#64748B] transition hover:bg-white hover:text-[#0F172A]"
            aria-label="Close filters"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <div className="max-h-[65vh] divide-y divide-[#E2E8F0] overflow-y-auto">
          {filterComponents.map((item, index) => (
            <div key={index}>{item}</div>
          ))}
        </div>
        <div
          className={classNames(
            "flex gap-2 border-t border-[#E2E8F0] bg-white p-3",
            hideResetAll ? "justify-end" : "justify-between",
          )}
        >
          {hideResetAll ? null : (
            <Button
              type="button"
              variant="secondary"
              onClick={() => resetFilters()}
            >
              Reset all
            </Button>
          )}
          <Button
            type="button"
            variant="primary"
            onClick={() => {
              setShowFilters(false);
              actionCall();
            }}
          >
            Apply filters
          </Button>
        </div>
      </div>
    </div>
  );
}
